import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { CgMenuLeft } from 'react-icons/cg'
import { FiEdit } from 'react-icons/fi'
import {
  useDeleteComplicationMutation,
  useGetComplicationByIdQuery
} from '../../../../services/rtk-query'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import { activarModalGenerico, setActiveComplication } from '../../../../store/slices/uiSlice'
import { ACTIONS } from '../../../../constants'
import { alertConfirm, toastAdapter } from '../../../../plugins'

export const Option = ({ cell, setAction, activo, ...rest }) => {
  const [deleteComplication] = useDeleteComplicationMutation()
  const dispatch = useDispatch()
  const [skip, setSkip] = useState(true)

  const { data, isSuccess, isFetching } = useGetComplicationByIdQuery(cell, {
    skip,
    refetchOnMountOrArgChange: true
  })
  const onEvent = () => {
    setSkip(false)
  }

  // inhabilitar registro
  const onDelete = () => {
    alertConfirm({
      title: 'Habilitar o inhabilitar registro',
      text: '¿Estas seguro de Habilitar o inhabilitar este registro?',
      icon: 'warning',
      confirmButtonText: 'Si, Habilitar o inhabilitar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result) {
        toastAdapter.promise({
          promise: deleteComplication({ id: cell, activo }).unwrap(),
          success: 'Registro Habilitado o inhabilitado con éxito',
          error: 'Error al Habilitar o inhabilitar el registro'
        })
      }
    })
  }

  // Actualizar el estado con los datos de la consulta cuando la consulta tenga éxito
  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setAction(ACTIONS.UPDATE)
        dispatch(setActiveComplication(data))
        dispatch(activarModalGenerico())

        setSkip(true)
      }, 300)
    }
  }, [isSuccess, data, dispatch, isFetching])
  return (
    <Dropdown flip drop="left">
      <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
        <CgMenuLeft />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={onEvent} disabled={rest.hasPermission}>
          <FiEdit /> Actualizar
        </Dropdown.Item>
        <Dropdown.Item
          className={classNames('text-danger', {
            opacity: rest.hasPermission
          })}
          onClick={onDelete}
          disabled={rest.hasPermission}
        >
          Habilitar / inhabilitar
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
